import React, { useRef }        from 'react';
import {
  useDispatch,
  useSelector
}                               from "react-redux";
import AlertPaneBrowseContainer from "../../../containers/AlertPaneBrowseContainer";

import AlertPaneLiveContainer  from "../../../containers/AlertPaneLiveContainer";
import CameraListContainer     from '../../../containers/CameraListContainer';
import PlaybackPlayer          from "../../../containers/PlaybackPlayer";
import { ApplicationState }    from "../../../store";
import {
  setSelectedEvent,
  setSortingEvents
}                              from "../../../store/alerts/actions";
import {
  AlertState,
  EventType
}                              from "../../../store/alerts/types";
import { cancelAllRequests }   from "../../../store/API/actions";
import { resetBrowsePanes }    from "../../../store/browse/actions";
import { BrowseState }         from "../../../store/browse/types";
import { setOpenedCameraList } from '../../../store/cameras/actions';
import { setCheckedPane }      from "../../../store/layouts/actions";
import { LayoutState }         from "../../../store/layouts/types";
import {
  setPlaybackmode,
  setTimelineDate
}                              from "../../../store/timeline/actions";
import { TimelineState }       from "../../../store/timeline/types";
import {
  chooseService,
  getCameraFromList
}                              from '../../../utils';
import BrowsePaneUpdater       from "../../browsemode/BrowsePaneUpdater";
import TitleCameraComponent    from "../../reusable/TitleCameraComponent";
import AlertTableComponent     from "../AlertsTableComponent/AlertTableComponent";
import './style.scss';


const AlertComponent = () => {
  const {checkedPane} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const {events, sorting, selectedEvent} = useSelector<ApplicationState, AlertState>(state => state.alerts);
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const {time} = useSelector<ApplicationState, TimelineState>(state => state.timeline);
  const {expandedVideoLayout} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  const isExpanded = typeof expandedVideoLayout === 'number';

  const cameraName = chooseService(
    () => selectedEvent ? selectedEvent.where : null,
    () => selectedEvent?.cameras ? getCameraFromList(selectedEvent.cameras, browsePanes?.[0]?.id)['a:Name'] : null
  )

  const doCheckedPane = (pane: number) => {
    if (checkedPane !== pane) dispatch(setCheckedPane(pane))
  };

  const onChangeSorting = (direction: number, type: string) => {
    dispatch(setSortingEvents(direction, type))
  };

  const onSelectEvent = (event: EventType | null) => {
    dispatch(cancelAllRequests());
    dispatch({type: 'cancelDeviceStatus'});
    dispatch(resetBrowsePanes());
    dispatch(setSelectedEvent(event));
    dispatch(setOpenedCameraList(false));
    dispatch(setPlaybackmode('pause'));
    event && dispatch(setTimelineDate(new Date(parseInt(event.when)).valueOf()));
  };

  const showCameraList = chooseService(
    () => false,
    () => selectedEvent?.cameras && selectedEvent?.cameras?.length > 1
  )

  return (
    <>
      <div className='alerts'
           style={{height: `${100 - window.CONFIG.footer.height}vh`}}
      >
        <div className='alerts__layout'
             style={{height: isExpanded ? '100%' : '50%'}}
        >
          <div className='alerts-layout__item'>
            {(checkedPane === 0 || checkedPane === 1) && showCameraList ? <CameraListContainer pane={0}/> : null}
            <div className={checkedPane === 0 ? 'alerts-layout-item__pane checked' : 'alerts-layout-item__pane '}
                 onClick={() => doCheckedPane(0)}
                 style={{width: expandedVideoLayout === 1 ? '0' : '100%'}}
            >
              <TitleCameraComponent pane={0}
                                    cameraName={cameraName}
              />
              <AlertPaneBrowseContainer/>
            </div>
            <div className={checkedPane === 1 ? 'alerts-layout-item__pane checked' : 'alerts-layout-item__pane '}
                 onClick={() => doCheckedPane(1)}
                 style={{width: expandedVideoLayout === 0 ? '0' : '100%'}}
            >
              <TitleCameraComponent pane={1}
                                    cameraName={cameraName}
              />
              <AlertPaneLiveContainer/>
            </div>
          </div>


          <div className='alerts-layout__item'>
            <AlertTableComponent events={events}
                                 direction={sorting.direction}
                                 type={sorting.type}
                                 onChangeSorting={onChangeSorting}
                                 selectedEvent={selectedEvent}
                                 onSelectEvent={onSelectEvent}
            />
          </div>
        </div>
      </div>
      <PlaybackPlayer/>
      <BrowsePaneUpdater time={time} dir={1}/>
    </>
  );
};

export default AlertComponent;